"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = providePopup;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _provideRenderToLayer = _interopRequireDefault(require("../hoc/provide-render-to-layer"));

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function providePopup(Target) {
  var ProvidePopup = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(ProvidePopup, _Component);

    var _super = _createSuper(ProvidePopup);

    function ProvidePopup() {
      var _this;

      (0, _classCallCheck2.default)(this, ProvidePopup);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _this.openPopup = function (createElement) {
        var popup = {};
        var onOpen;
        var onResolve;
        var onReject;
        popup.opened = new Promise(function (resolve) {
          onOpen = resolve;
        });
        popup.closed = new Promise(function (resolve, reject) {
          onResolve = function onResolve(arg) {
            _this.props.unrenderAtLayer(popup.element).then(function () {
              resolve(arg);
            });
          };

          onReject = function onReject(arg) {
            _this.props.unrenderAtLayer(popup.element).then(function () {
              reject(arg);
            });
          };
        });
        popup.element = _this.props.renderToLayer(createElement(onResolve, onReject), {
          onOpen: onOpen,
          onRequestClose: onReject
        });
        popup.close = onReject;
        return popup;
      };

      _this.closePopup = function (popup) {
        popup.close();
      };

      return _this;
    }

    (0, _createClass2.default)(ProvidePopup, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            renderToLayer = _this$props.renderToLayer,
            unrenderAtLayer = _this$props.unrenderAtLayer,
            props = (0, _objectWithoutProperties2.default)(_this$props, ["renderToLayer", "unrenderAtLayer"]);
        return _react.default.createElement(Target, (0, _extends2.default)({}, props, {
          openPopup: this.openPopup,
          closePopup: this.closePopup
        }));
      }
    }]);
    return ProvidePopup;
  }(_react.Component);

  ProvidePopup.propTypes = process.env.NODE_ENV !== "production" ? {
    renderToLayer: _propTypes.default.func.isRequired,
    unrenderAtLayer: _propTypes.default.func.isRequired
  } : {};
  return (0, _provideRenderToLayer.default)(ProvidePopup);
}